import axios from "axios";

const API_URL = 'https://station-find-bke.onrender.com/api/user';
// const API_URL = 'http://localhost:5000/api/user';
export const getUser = async () => {
    try {
        const response = await axios.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching Users:', error);
        throw error;
    }
};

export const getSingleUser = async (username) => {
    try {
        const response = await axios.get(`${API_URL}/${username}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching Single User:', error);
        throw error;
    }
}

export const getAuthUser = async (userId) => {
    try {
        const response = await axios.get(`${API_URL}auth/${userId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching Single User:', error);
        throw error;
    }
}



